import React from 'react';
import './PetAnimations.css';

export default function ChickenSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#F5F0E8';
  const lightColor = color ? lighten(color) : '#FFFFFF';
  const darkColor = color ? darken(color) : '#D5D0C8';
  const combColor = '#CC3333';
  const beakColor = '#E8A020';
  const legColor = '#D4952A';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Tail feathers */}
      <path d="M82 58C90 52 92 42 88 38C85 35 82 40 82 46" fill={darkColor} />
      <path d="M80 60C88 56 92 48 89 43C86 40 83 44 82 50" fill={bodyColor} />
      <path d="M78 62C86 58 90 52 87 47C84 44 82 48 80 54" fill={darkColor} />
      {/* Body */}
      <ellipse cx="58" cy="68" rx="26" ry="22" fill={bodyColor} />
      {/* Wing */}
      <ellipse cx="65" cy="66" rx="14" ry="12" fill={darkColor} />
      <ellipse cx="64" cy="66" rx="11" ry="9" fill={lightColor} opacity="0.5" />
      {/* Legs */}
      <line x1="50" y1="88" x2="50" y2="100" stroke={legColor} strokeWidth="2.5" />
      <line x1="64" y1="88" x2="64" y2="100" stroke={legColor} strokeWidth="2.5" />
      {/* Feet */}
      <path d="M44 100L50 97L56 100" stroke={legColor} strokeWidth="2" strokeLinecap="round" fill="none" />
      <path d="M58 100L64 97L70 100" stroke={legColor} strokeWidth="2" strokeLinecap="round" fill="none" />
      <line x1="50" y1="97" x2="50" y2="102" stroke={legColor} strokeWidth="2" strokeLinecap="round" />
      <line x1="64" y1="97" x2="64" y2="102" stroke={legColor} strokeWidth="2" strokeLinecap="round" />
      {/* Head */}
      <circle cx="40" cy="42" r="16" fill={bodyColor} />
      {/* Comb */}
      <path d="M36 28C36 28 38 22 40 24C42 26 42 20 44 22C46 24 46 20 48 24C48 28 44 30 40 30Z" fill={combColor} />
      {/* Wattle */}
      <ellipse cx="34" cy="52" rx="3" ry="5" fill={combColor} />
      {/* Beak */}
      <path d="M26 43L34 40L34 46Z" fill={beakColor} />
      <path d="M26 43L34 43L34 46Z" fill="#C88818" />
      {/* Eyes */}
      <circle cx="36" cy="39" r="3.5" fill="white" />
      <circle cx="37" cy="39" r="2" fill="#1A1A1A" />
      <circle cx="37.5" cy="38" r="0.8" fill="white" />
      {/* Chest fluff */}
      <ellipse cx="42" cy="60" rx="10" ry="8" fill={lightColor} />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
